<table>
  <tr>
    <td class="propLabel">Fastener:</td>
    <td>

      <div *ngFor="let panel of panelTypes" (click)="selectFastner(panel)" class="pickerTile"
        [ngClass]="{'disabled':(selectedFastener!='' && selectedFastener!=panel.id)}">

        <img class="pickerImg" [src]="panel.ImageUrl">
        {{panel.Description}}

      </div>



    </td>
  </tr>
  <tr>
    <td class="propLabel">Color: </td>
    <td>

      <div *ngFor="let color of paintColors" (click)="selectColor(color)" class="pickerTile"
        [ngClass]="{'disabled':(selectedColor!='' && selectedColor!=color.ColorCode)}">

        <div class="pickerImg" [style.backgroundColor]="color.Color"
          [style.backgroundImage]="color.ImageUrl ? 'url(' + d.cms(color.ImageUrl) + ')' : 'none'"></div>
        {{color.ColorDescription}}

      </div>


    </td>
  </tr>
</table>